import React, { use, useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

const ShareButton = ({url,title,description}) => {


    const urlToShare = url ? url : window.location.href;

    const handleShare = async () => {
        

        if (Capacitor.isNativePlatform()) {
            try {
                await Share.share({
                    title: title,
                    text: description,
                    url: urlToShare,
                    dialogTitle: title,
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    // Fallback: vágólap
                    try {
                        await navigator.clipboard.writeText(urlToShare);
                        alert('Link a vágólapra másolva!');
                    } catch (e) {
                        alert(urlToShare);
                    }
                }
            }
            return;
        }

        if (!navigator.share) {
            // Fallback: vágólap
            try {
                await navigator.clipboard.writeText(urlToShare);
                alert('Link a vágólapra másolva!');
            } catch (e) {
                alert(urlToShare);
            }
            return;
        }

        try {
            await navigator.share({
            title: title,
            text: description,
            url: urlToShare,
            });
        } catch (err) {
            if (err.name !== 'AbortError') {
                // Fallback: vágólap
                try {
                    await navigator.clipboard.writeText(urlToShare);
                    alert('Link a vágólapra másolva!');
                } catch (e) {
                    alert(urlToShare);
                }
            }
        }
    };

    return (<div className="share-button">
        <ReactSVG onClick={handleShare} src="/assets/images/share.svg" />
    </div>);
}

export default ShareButton;